import React from 'react'
import { pluralizeToString } from 'lib/string/pluralize'
import { generateRoomOccupants } from 'lib/offer/occupancyUtils'
import { OfferPageFilterType, OfferPageState } from 'contexts/OfferPage/offerPageStateReducer'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import ModalBody from 'components/Luxkit/Modal/ModalBody'
import ModalHeader from 'components/Luxkit/Modal/ModalHeader'
import FlashMobileStickyHeaderFilters from 'components/OfferPage/FlashHotel/FlashHotelMobileVariant/FlashMobileStickyHeaderFilters'
import MobileMultipleRoomsBookingContent from '../MobileMultipleRoomsBookingContent'

interface Props {
  rooms?: Array<App.RoomOccupants>;
  activeFilter?: OfferPageFilterType;
  onClose: () => void;
  onBack?: () => void;
}

const defaultRooms = [generateRoomOccupants()]

function MobileMultipleRoomsBookingSelectRoomsModal(props: Props) {
  const { rooms = defaultRooms, activeFilter, onClose, onBack } = props

  const isConfirmStep = activeFilter === 'multiRoomConfirm'

  return (
    <>
      <ModalHeader
        title={isConfirmStep ? 'Confirm room selection' : `Select your ${pluralizeToString('room', rooms.length)}`}
        onCloseButtonClick={onClose}
        onBackButtonClick={onBack}
      >
        <FlashMobileStickyHeaderFilters onAfterCloseCapacity={onClose} />
      </ModalHeader>
      <ModalBody>
        <MobileMultipleRoomsBookingContent scrollToSelections />
      </ModalBody>
    </>
  )
}

type MappedProps = Pick<Props, 'rooms' | 'activeFilter'>

export default withOfferPageAndReduxState((state: OfferPageState): MappedProps => ({
  rooms: state.rooms,
  activeFilter: state.activeFilter,
}), MobileMultipleRoomsBookingSelectRoomsModal)
